import { SOCIAL_NETWORK } from "../hub";
import { SOCIAL_STATUS } from "./social-status";
import { z } from "zod";

export const SocialAccountDtoSchema = z.object({
  id: z.number(),
  socialName: z.nativeEnum(SOCIAL_NETWORK),
  userId: z.string(),
  username: z.string(),
  avatarUrl: z.string(),
  createdAt: z.coerce.date(),
  status: z.nativeEnum(SOCIAL_STATUS),
});

export type SocialAccountDto = z.infer<typeof SocialAccountDtoSchema>;

export const XPostDataDtoSchema = z.object({
  id: z.string(),
  text: z.string(),
  createdAt: z.coerce.date(),
  author: z.object({
    id: z.string(),
    username: z.string(), // Default field - always present
    name: z.string(), // Default field - always present
    avatarUrl: z.string().optional(), // Optional - profile_image_url is not a default field
  }),
  media: z
    .array(
      z.object({
        type: z.enum(["photo", "video", "animated_gif"]), // Default field - always present
        url: z.string().optional(), // Optional field - must be requested via media.fields
        previewUrl: z.string().optional(), // Optional field
        width: z.number().optional(), // Optional field
        height: z.number().optional(), // Optional field
      }),
    )
    .optional(),
  metrics: z
    .object({
      likeCount: z.number(),
      retweetCount: z.number(),
      replyCount: z.number(),
      viewCount: z.number().optional(), // impression_count may be 0 for non-owned tweets
    })
    .optional(),
});

export type XPostDataDto = z.infer<typeof XPostDataDtoSchema>;

export const XPostDataWithCommentDtoSchema = z.object({
  postData: XPostDataDtoSchema.optional(),
  comment: z.string(),
});

export type XPostDataWithCommentDto = z.infer<typeof XPostDataWithCommentDtoSchema>;
